<template>
  <!-- NEWSLETTER SIGNUP -->
  <NewsletterForm />
</template>

<script>
import NewsletterForm from "@/components/NewsletterForm.vue";

export default {
  components: {
    NewsletterForm,
  },
};
</script>
